import padStart from 'lodash/padStart'

export function formatTime (seconds) {
  const m = Math.floor(seconds / 60)
  const s = seconds % 60

  return `${padStart(m, 2, 0)}:${padStart(s, 2, 0)}`
}

export function timeStrToSeconds (timeStr){
  let timeArray = timeStr.split(':');
  if (timeArray.length !== 2) return '非法时间格式';
  return parseInt(timeArray[0], 10) * 60 + parseInt(timeArray[1], 10);
}

//标准配置 需改变
export function renderBySource (query, what, renderFunc) {
  let {source, etype} = query;
  const SOURCE_MAP = {
    zhikeyun: {
      default: {
        askTeacher: false,
        pigai: false,
        ctqa: false,
        seeAnswer: true,
        correction: false,
      },
      test: {
        askTeacher: false,
        pigai: false,
        ctqa: false,
        seeAnswer: true,
        correction: false,
      }
    },
    smart: {
      default: {
        askTeacher: false,
        pigai: false,
        ctqa: true,
        seeAnswer: false,
        correction: true,
      },
      test: {
        askTeacher: false,
        pigai: false,
        ctqa: false,
        seeAnswer: false,
        correction: true,
      }
    },
    zhike: {
      default: {
        askTeacher: true,
        pigai: true,
        ctqa: true,
        seeAnswer: true,
        correction: true,
      },
      test: {
        askTeacher: true,
        pigai: true,
        ctqa: true,
        seeAnswer: false,
        correction: true,
      }
    }
  }

  source = source || 'zhike';
  etype = etype || 'default';

  if (SOURCE_MAP[source] && SOURCE_MAP[source][etype] && SOURCE_MAP[source][etype][what]) {
    return renderFunc()
  } else {
    return null
  }
}



/** WEBPACK FOOTER **
 ** ./src/common/utils.js
 **/